import { BenefitTypeEnum } from './benefit-type-enum.generated';

const x: { [index: string]: string } = {};
x[BenefitTypeEnum.Unknown] = 'Unknown';
x[BenefitTypeEnum.Medical] = 'Medical';
x[BenefitTypeEnum.Dental] = 'Dental';
x[BenefitTypeEnum.Vision] = 'Vision';
x[BenefitTypeEnum.HospitalIndemnity] = 'Hospital Indemnity';
x[BenefitTypeEnum.HSA] = 'HSA';
x[BenefitTypeEnum.FSA] = 'FSA';
x[BenefitTypeEnum.BasicLife] = 'Basic Life';
x[BenefitTypeEnum.SuppLife] = 'Supp Life';
x[BenefitTypeEnum.BasicADD] = 'Basic AD&D';
x[BenefitTypeEnum.SuppADD] = 'Supplemental AD&D';
x[BenefitTypeEnum.Disability] = 'Disability';
x[BenefitTypeEnum.RetirementPlan] = 'Retirement Plan';
x[BenefitTypeEnum.Accident] = 'Accident';
x[BenefitTypeEnum.Annuity] = 'Annuity';
x[BenefitTypeEnum.BasicLifeADD] = 'Basic Life AD&D';
x[BenefitTypeEnum.Cancer] = 'Cancer';
x[BenefitTypeEnum.CriticalIllness] = 'Critical Illness';
x[BenefitTypeEnum.Custom] = 'Custom';
x[BenefitTypeEnum.EmployeeAssistancePlan] = 'Employee Assistance Plan';
x[BenefitTypeEnum.HRA] = 'HRA';
x[BenefitTypeEnum.LongTermCare] = 'Long Term Care';
x[BenefitTypeEnum.NJTemporaryDisability] = 'NJ Temporary Disability';
x[BenefitTypeEnum.ParkingReiumbursement] = 'Parking Reiumbursement';
x[BenefitTypeEnum.Prescription] = 'Prescription';
x[BenefitTypeEnum.PurchasedPaidLeave] = 'Purchased Paid Leave';
x[BenefitTypeEnum.ShortTermDisability] = 'Short Term Disability';
x[BenefitTypeEnum.SuppLifeADD] = 'Supp Life AD&D';
x[BenefitTypeEnum.TransportationReimbursement] = 'Transportation Reimbursement';
x[BenefitTypeEnum.UniversalLife] = 'Universal Life';
x[BenefitTypeEnum.VoluntaryLife] = 'Voluntary Life';
x[BenefitTypeEnum.WholeLife] = 'Whole Life';
x[BenefitTypeEnum.PetInsurance] = 'Pet Insurance';
x[BenefitTypeEnum.IdentityTheft] = 'Identity Theft';
x[BenefitTypeEnum.Waive] = 'Waive';
export const BenefitTypeEnumDescriptions: { [indexer: string]: string } = x;
